import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/layout/Layout';
import GlobalStyles from './styles/globalStyles';
import Notifications from './components/common/Notifications';
import { ToastProvider } from './components/common/ToastProvider';

// Pages
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import Policies from './pages/Policies';
import Settings from './pages/Settings';
import Manage from './pages/Manage';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ClaimsTriage from './pages/ClaimsTriage';
import ClaimDetails from './pages/ClaimDetails';
import UnderwritingDetails from './pages/UnderwritingDetails';
import UnderwritingHub from './pages/UnderwritingHub';
import Workbench from './pages/Workbench';
import WorkbenchClaimDetails from './pages/WorkbenchClaimDetails';
import ClaimCreate from './pages/ClaimCreate';
import AIIntelligenceDetail from './pages/AIIntelligenceDetail';

// Context
import { AuthProvider } from './context/AuthContext';
import ErrorBoundary from './utils/ErrorBoundary';
import { useRefresh } from './context/RefreshContext';
import  AuthWatcher  from './utils/authWatcher';
import MsalHandler from './utils/MsalHandler';
import { useMsal } from '@azure/msal-react';
import { configureMsal } from './utils/apiUtils';
import WorkbenchListing from './pages/WorkbenchListing';

function App() {
  const { refreshKey } = useRefresh();

  const { inProgress, instance } = useMsal();

  useEffect(() => {
  configureMsal(instance);
  console.log("Instance is get called")
}, [instance]);

  // 🔥 Block whole app until MSAL is ready
  if (inProgress !== "none") {
    return <div className="fullscreen-loader"
      style={{
        display: 'flex',
        justifyContent: 'center', 
        alignItems: 'center',     
        height: '100vh',          
        width: '100%'             
      }}
    >
        <img
              src="/images/spinning-dots.svg"
              alt="loading..."
              style={{
                width:'200px',
                height:'200px'
              }}
            />
    </div>;
  }

  return (
    <AuthProvider>
        <ToastProvider>
      
        <Router>
          <MsalHandler />
          <AuthWatcher />

          <GlobalStyles />
          <Notifications />
          <Routes>
            {/* Login route */}
            <Route path="/login" element={<Login />} />
            <Route path="/login/:provider" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            
            {/* Main application routes with layout */}
            <Route path="/" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <WorkbenchListing />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/dashboard" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                     <Dashboard />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/listing" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <WorkbenchListing />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/workbench/:manualTaskId" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <Workbench />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/workbench-claim-details/:claimId/:taskId" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <WorkbenchClaimDetails />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/claim-create" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <ClaimCreate />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/ai-intelligence/:cardCode" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <AIIntelligenceDetail />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/policies" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                    <Policies />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/settings" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                  <Settings />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/manage" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <ErrorBoundary>
                  <Manage />
                  </ErrorBoundary>
                </Layout>
              </ProtectedRoute>
            } />
            
            {/* Default redirect to login */}
            <Route path="*" element={
              <ProtectedRoute key={refreshKey}>
                <Layout>
                  <Navigate to="/login" replace />
                </Layout>
              </ProtectedRoute>
            } />
          </Routes>
        </Router>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
